import React, { ReactNode, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface ModalProps {
  open: boolean;
  title: string;
  description?: string;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
}
export function Modal({
  open,
  title,
  description,
  onClose,
  children,
  footer
}: ModalProps) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  return <AnimatePresence data-id="element-770" data-mp="3vmew3rvf72pq">
      {open && <motion.div className="fixed inset-0 z-50 flex items-center justify-center bg-navy/40 p-4 backdrop-blur-sm" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} onMouseDown={onClose} data-id="element-771" data-mp="3qmae1xev5zxe">
          <motion.div role="dialog" aria-modal="true" aria-labelledby="modal-title" className="w-full max-w-lg rounded-2xl bg-white shadow-lift" initial={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 8,
        scale: 0.98
      }} transition={{
        duration: 0.18,
        ease: 'easeOut'
      }} onMouseDown={e => e.stopPropagation()} data-id="element-772" data-mp="2i3pjhhlugbm9">
            <div className="flex items-start justify-between gap-4 px-6 pt-6" data-id="element-773" data-mp="1zb4y0l8h58sh">
              <div data-id="element-774" data-mp="24592mxu9p4qe">
                <h2 id="modal-title" className="text-lg font-semibold text-navy" data-id="element-775" data-mp="245r8mm6qexbi">
                  {title}
                </h2>
                {description && <p className="mt-1 text-sm text-muted" data-id="element-776" data-mp="1udbmrdsbdolc">{description}</p>}
              </div>
              <button type="button" onClick={onClose} aria-label="Close" className="rounded-lg p-1.5 text-muted transition hover:bg-slate-100 hover:text-navy" data-id="element-777" data-mp="1ge3n6js8oegm">
                <XIcon className="h-5 w-5" data-id="element-778" data-mp="3n3x7fqfc3n8g" />
              </button>
            </div>
            <div className="px-6 py-5" data-id="element-779" data-mp="3ib45fab92t02">{children}</div>
            {footer && <div className="flex justify-end gap-2 rounded-b-2xl border-t border-slate-100 bg-canvas/60 px-6 py-4" data-id="element-780" data-mp="3dc9okdwufeil">{footer}</div>}
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}